import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_BLUE } from "../../config/constants";

const Connector11FBlue11CBlack = ({ state, workState }) => (
	<g id="Track-11F-blue-connector" transform="translate(2207.000000, 478.000000)">
		<g transform="translate(11.041508, 0.000000)" strokeLinecap="round">
			<path
				d="M2.9584915,143.5 L4.9052173,144.960044 C19.9085603,156.212552 28.2060009,174.287359 26.9584915,193 L26.9584915,193 L26.9584915,193"
				strokeWidth={tracksWidth}
				stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			/>
		</g>
	</g>
);

export default Connector11FBlue11CBlack;
